module.exports = __webpack_public_path__ + "static/media/celeb.066e274b.png";